module.exports = __webpack_public_path__ + "assets/0e1fe1deb24c29d3b28b3846bd853f79.png";